/* eslint-disable @next/next/no-html-link-for-pages */
/* eslint-disable @next/next/no-img-element */
import React, { useContext } from "react";
import { LogContext } from "context/log";
import { WpYoastHead } from "types/wp-yoast-head";
import { endpoints } from "config";
import HeadTagsRenderer from "components/HeadTagsRenderer";
import HomePageHeroSlider from "components/HomePageHeroSlider";
import HomepageInstafeed from "../components/HomepageInstafeed";
import RockstarFooter from "components/RockstarFooter";
import RockstarHeader from "components/RockstarHeader";
import TopCtaBanner from "components/TopCtaBanner";
import { generatePageId } from "@pepdirect/helpers/analyticsLogger";
import { PAGE_TYPE_ENUM } from "@pepdirect/shared/types";

export default function Home(): JSX.Element {
  const { useLogPageView } = useContext(LogContext);

  const seoTags: WpYoastHead = {
    title: "Rockstar Energy - Homepage",
    description:
      "Welcome to Rockstar Energy, where the grind never stops. Fuel your hustle and check out what&#039;s new at Rockstar Energy.",
    canonical: `${endpoints.web}/`,
    og_locale: "en_US",
    og_type: "website",
    og_title: "Rockstar Energy - Homepage",
    og_description:
      "Welcome to Rockstar Energy, where the grind never stops. Fuel your hustle and check out what&#039;s new at Rockstar Energy.",
    og_url: `${endpoints.web}/`,
    og_site_name: "Rockstar Energy",
    og_image: [
      {
        url: `https://www.datocms-assets.com/74813/1658772651-rockstar-social-1-1024x1024.png`,
      },
    ],
    twitter_card: "summary_large_image",
  };

  useLogPageView({
    pageType: PAGE_TYPE_ENUM.home,
    pageCategory: undefined,
    pageTitle: seoTags.title || "",
    id: generatePageId("home"),
  });

  return (
    <>
      <HeadTagsRenderer yoastJson={seoTags} />
      <div id="page" className="site">
        <a className="skip-link screen-reader-text" href="#content">
          Skip to content
        </a>
        <div className="site-header-block">
          <TopCtaBanner />
          <RockstarHeader />
        </div>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main" role="main">
              <article
                id="post-39"
                className="post-39 page type-page status-publish hentry entry"
              >
                <div className="entry-content focus">
                  <HomePageHeroSlider />
                  <HomepageInstafeed />
                  <div
                    style={{ height: "44px" }}
                    aria-hidden="true"
                    className="wp-block-spacer"
                  ></div>
                </div>
              </article>
            </main>
          </div>
        </div>
        <RockstarFooter />
      </div>
    </>
  );
}
